import { render } from "./VaIconNotification.vue?vue&type=template&id=59c3525f"
import script from "./VaIconNotification.vue?vue&type=script&lang=js"
export * from "./VaIconNotification.vue?vue&type=script&lang=js"

import "./VaIconNotification.vue?vue&type=style&index=0&id=59c3525f&lang=scss"
script.render = render

export default script